import HeaderSearch from './HeaderSearch';
import Search from './Search';

export { Search, HeaderSearch };
